import { render } from "./base-loader.vue?vue&type=template&id=d9a343ce"
import script from "./base-loader.vue?vue&type=script&lang=js"
export * from "./base-loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__